module.exports = __webpack_public_path__ + "static/media/29ADMSPC23.459e7d43.jpg";